export enum ContactUsTypes {
	Other = 'other',
	Tenant = 'tenant',
	Landlord = 'landlord_manager',
	Technical = 'technical',
	Invoicing = 'invoicing',
	Partner = 'institution_partner',
}
